import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import t from 'tcomb-form';

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}

function parseJSON(response) {
    return response.json();
}

export default class FormDropzone extends Component {
    static displayName = 'FormDropzone';
    static propTypes = {
        options: PropTypes.shape({
            url: PropTypes.string.isRequired,
            value: PropTypes.string,
            validateImage: PropTypes.func
        }),
        value: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            hasError: false,
            errors: [],
            value: props.value
        };
    }

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    /**
     * @param {Image} image
     * @param {Function} validate
     * @memberof FormDropzone
     */
    validateImageOnDrop = (image, validate) => {
        if (validate) {
            const validationResult = validate(image);

            this.setState({
                hasError: !R.isEmpty(validationResult),
                errors: validationResult
            });
        }
    };

    displayErrors = () => {
        if (R.isEmpty(this.state.errors)) {
            return null;
        }
        const mapIndexed = R.addIndex(R.map);
        const errors = mapIndexed((errMsg, i) => <li key={i}>{errMsg}</li>)(this.state.errors);
        return (
            <label className="control-label">
                Warning:
                <ul>{errors}</ul>
            </label>
        );
    };

    onDrop = files => {
        if (!files.length) return;

        const file = R.head(files);

        const {url, validateImage} = this.props.options;

        const image = new Image();
        image.onload = () => {
            this.validateImageOnDrop(image, validateImage);
        };
        image.src = URL.createObjectURL(file);

        const data = new FormData();

        data.append('file', file);
        this.setState(
            {
                isLoading: true,
                value: null
            },
            () => {
                fetch(url, {
                    method: 'post',
                    body: data,
                    credentials: 'same-origin'
                })
                    .then(checkStatus)
                    .then(parseJSON)
                    .then(response => {
                        setTimeout(() => {
                            this.setState({
                                isLoading: false,
                                value: response.image.url
                            });
                            this.props.onChange(response.image.url, this.props.ctx.path);
                        }, 8000);
                    })
                    .catch(error => {
                        if (error instanceof Error && R.has('response', error)) {
                            return error.response.json().then(response => {
                                const {error} = response;
                                return this.setState({
                                    isLoading: false,
                                    hasError: true,
                                    errors: [error]
                                });
                            });
                        }

                        return this.setState({
                            isLoading: false,
                            hasError: true,
                            errors: ['There was a problem uploading the image. Please try again.']
                        });
                    });
            }
        );
    };

    render() {
        const label = this.props.options.label || this.props.ctx.label;
        const {value, isLoading, hasError} = this.state;
        const style = {
            backgroundImage: value && `url(${value})`,
            backgroundSize: 'cover',
            hasError
        };

        const labelNode = React.isValidElement(label) ? (
            label
        ) : (
            <label className="control-label">{label}</label>
        );

        const dropzoneCaptionMessage = isLoading
            ? 'Uploading and Converting... Please Wait!'
            : 'Click here to upload an image';

        const dropzoneCaption = <div className="dropzone-caption">{dropzoneCaptionMessage}</div>;

        const displayErrors = this.displayErrors();

        return (
            <div className={classNames('form-group', {'has-error': hasError})}>
                <label className="control-label">{labelNode}</label>
                <Dropzone className="dropzone" style={style} onDrop={this.onDrop} multiple={false}>
                    {!value && dropzoneCaption}
                </Dropzone>
                {displayErrors}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_dropzone.js